import { ContentLanguageLabelModel } from '@fi-shared/models';
import { TemplatePlaceholderModel } from './template-placeholder.model';
import { TemplateType } from './types/template-type';
import { FiDateFormatOptions } from '@fi-shared/utils/format-date';
import { AccessRightFilterCollectionModel } from '@fi-shared/models';
import { TemplatePlaceHolderControlModel } from '@fi-app/template/template-placeholder-control.model';
import { IMediaBankFileReference } from '@fi-shared/media-bank';
import { ContentLanguagesService } from '@fi-app/utilities/fi-services/content-languages.service';
import { Injector } from '@angular/core';
import { FiCustomerDataService } from '@fi-shared/fi-shared-services/fi-customer-data.service';
import { FiFormatDateService } from '@fi-shared/fi-format-date/fi-format-date.service';

export class TemplateModel {
    Id: number;
    Name: string;
    Description: string;
    AccessRightFilterCollection: AccessRightFilterCollectionModel;
    PlaceHolderCollection: TemplatePlaceholderModel[];
    Properties: string;
    TemplateType: any;
    BaseUrl: string;
    CreatedOn: any;
    CreatedByUserId: number;
    CreatedByUserName: string;
    CreatedOnDate: string;
    ChangedByUserId: number;
    ChangedByUserName: string;
    ChangedOn: any;
    ChangedOnDate: string;
    PreviewFileName: string;
    IsFavorite: boolean;
    IsDeleted: boolean;
    Names: ContentLanguageLabelModel[] = [];
    Descriptions: ContentLanguageLabelModel[] = [];
    IsInUse: boolean;
    HasViewAccessAsSuperAdmin: boolean;
    MediaBankFileReferences: IMediaBankFileReference[] = [];
    DocumentIds: number[] = [];

    constructor(data, injector: Injector) {
        data = data || {
            Names: [],
            Descriptions: [],
            PlaceHolderCollection: [],
            MediaBankFileReferences: [],
            DocumentIds: [],
        };

        this.Id = data.Id;
        this.Name = data.Name;
        this.Description = data.Description;

        const fiFormatDateService = injector.get(FiFormatDateService);
        const contentLanguagesService = injector.get(ContentLanguagesService);
        contentLanguagesService.InitializeContentLanguagesArray(this.Names, data.Names);
        contentLanguagesService.InitializeContentLanguagesArray(this.Descriptions, data.Descriptions);

        this.AccessRightFilterCollection = new AccessRightFilterCollectionModel();
        if (data.AccessRightFilterCollection) {
            this.AccessRightFilterCollection.InitializeAccessRightFilterCollection(data.AccessRightFilterCollection);
        }

        this.PlaceHolderCollection = [];
        const customerDataService: FiCustomerDataService = injector.get(FiCustomerDataService);
        (data.PlaceHolderCollection ?? []).forEach((placeHolder) => {
            this.PlaceHolderCollection.push(
                new TemplatePlaceholderModel(customerDataService.customerData, placeHolder),
            );
        });

        this.Properties = '';

        this.TemplateType = data.TemplateType || TemplateType.Document;
        this.BaseUrl = data.BaseUrl;
        this.CreatedByUserId = data.CreatedByUserId;
        this.CreatedByUserName = data.CreatedByUserName;
        this.CreatedOn = data.CreatedOn;
        this.CreatedOnDate = fiFormatDateService.formatDate(this.CreatedOn, FiDateFormatOptions);
        this.ChangedByUserId = data.ChangedByUserId;
        this.ChangedByUserName = data.ChangedByUserName;
        this.ChangedOn = data.ChangedOn;
        this.ChangedOnDate = fiFormatDateService.formatDate(this.ChangedOn, FiDateFormatOptions);
        this.PreviewFileName = data.PreviewFileName;
        this.IsFavorite = data.IsFavorite;
        this.IsDeleted = data.IsDeleted;
        this.IsInUse = data.IsInUse;
        this.HasViewAccessAsSuperAdmin = data.HasViewAccessAsSuperAdmin;
        this.MediaBankFileReferences = data.MediaBankFileReferences;
        this.DocumentIds = data.DocumentIds;
    }

    FindPlaceHolderControlById(Id): TemplatePlaceHolderControlModel {
        var result: any = false;
        this.PlaceHolderCollection.forEach(function (PlaceHolder) {
            PlaceHolder.ControlCollection.forEach(function (Control) {
                if (Control.Id == Id) {
                    result = Control;
                }
            });
        });
        return result;
    }
}
